import React from 'react'
import { Bullet, Bullets, Info, Page, Screenshot, Section } from '../../../components/CommandControlComponents'

const Metrics = () => (
  <Page
    title="Control Metrics"
    intro="The metrics screen gives commanders a live summary of incident, patient, staffing, resource, and ePCR activity."
  >
    <Section title="Header chips">
      <Bullets>
        <Bullet>The control room header shows quick metric chips for total incidents, patients, staff on duty, available resources, and draft ePCRs.</Bullet>
        <Bullet>Click any metric chip, or the view metrics chip, to open the full metrics dialog.</Bullet>
        <Bullet>Available resources and staff on duty are current-state metrics.</Bullet>
      </Bullets>
    </Section>

    <Section title="Metrics dialog">
      <Bullets>
        <Bullet>Total Incidents includes closed incidents for the selected period.</Bullet>
        <Bullet>Patients Treated counts event-linked ePCRs for the selected period.</Bullet>
        <Bullet>Staff On Duty counts unique staff assigned to non-off-duty resources.</Bullet>
        <Bullet>Available Resources counts resources currently marked Available or Mobile & Available.</Bullet>
        <Bullet>ePCR review status cards show counts such as Draft or other review states.</Bullet>
        <Bullet>Charts show patient outcomes and the most common presenting complaints.</Bullet>
      </Bullets>
      <Screenshot url="command-control/control-metrics.png">
        Control Metrics dialog with summary cards, day selector, patient outcomes chart, and presenting complaints chart.
      </Screenshot>
    </Section>

    <Section title="Multi-day events">
      <Bullets>
        <Bullet>If the linked event spans more than one day, the metrics dialog shows a day selector.</Bullet>
        <Bullet>The selector defaults to All days.</Bullet>
        <Bullet>Choosing a day filters total incidents, patients treated, ePCR review counts, patient outcomes, and presenting complaints.</Bullet>
        <Bullet>Live current-state metrics, such as available resources and staff on duty, remain current rather than historical.</Bullet>
      </Bullets>
      <Info>
        Day filtering uses incident creation dates and ePCR creation dates. It is designed for operational review during multi-day events.
      </Info>
    </Section>
  </Page>
)

export default Metrics
